export default {
    primary: {
        main: "#10c98d",
        contrastText: "#FFF",
        backgroundColor: "#2f3243"
    },
    secondary: {
        main: "#ff5fa1"
    },
    text: {
        primary: "#FFF",
        secondary: "#a4acc4",
        disabled: "#b18080"
    }
}